import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
// import { types } from "../action-types";
import {types} from "../action-types";
import {getAllPaymentsApi} from "../../API/API"


function* getAllPaymentsSaga(action) {
    try {
      const response = yield call(() => getAllPaymentsApi(action.payload));
      yield put({
        type: types.GET_ALL_PAYMENTS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: types.GET_ALL_PAYMENTS_FAILURE, error });
    }
  }

  export function* watchGetAllPaymentsSaga() {
    yield takeLatest(types.GET_ALL_PAYMENTS_REQUESTED, getAllPaymentsSaga);
  } 